/**
 * @Author: Calvin Green <calvin>
 * @Date:   2021-06-16T15:19:01+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2021-06-17T14:58:49+02:00
 * @Copyright: Diversitude 2021
 */

/* eslint-disable */
import _ from 'lodash';
import './custom_webix.css';

export default {
    //eslint-disable-next-line no-unused-vars
    install(Vue) {
        //*Init webix datatable
        window.webix = webix;
        function plugin_data_handler(value) {
            var view = $$(this.webixId);
            if (typeof value === "object") {
                if (this.copyData)
                    value = webix.copy(value);
                if (view.setValues)
                    view.setValues(value);
                else if (view.parse) {
                    view.clearAll();
                    view.parse(value)
                }
            } else if (view.setValue)
                view.setValue(value);
            var subs = view.queryView(function (sub) {
                return sub.hasEvent && sub.hasEvent("onValue");
            }, "all");
            if (subs.length) {
                for (var i = 0; i < subs.length; i++) {
                    subs[i].callEvent("onValue", [value]);
                }
            }
        }

        Vue.component('webix-table-display', {
            props: ['config', 'value', 'copyData'],
            watch: {
                value: {
                    handler: plugin_data_handler
                }
            },
            template: "<div></div>",
            mounted: function () {
                var config = webix.copy(this.config);
                config.$scope = this;

                this.webixId = webix.ui(config, this.$el);
                if (this.value)
                    plugin_data_handler.call(this, this.value);
            },
            destroyed: function () {
                webix.$$(this.webixId).destructor();
            }
        })
        //Add mixin
        Vue.mixin({
            created() {

            },
        })

        //* Define the element used to display the render view
        Vue.component('spreadify-plugin', {
            data: () => ({
                finishedLoading: false,
                uid: "",
                editableClick:{
                    onItemClick(id, e, node){
                        var el = this.$scope.$parent;
                        let rowColumn = id.row + '|' + id.column;
                        let index = _.findIndex(el.config.editableCells, {id: rowColumn});
                        if(index == -1){
                            this.editCancel();
                            this.clearSelection();
                        }
                    },
                    onBeforeSelect(id, preserve){
                        var el = this.$scope.$parent;

                        let rowColumn = id.row + '|' + id.column;
                        let index = _.findIndex(el.config.editableCells, {id: rowColumn});
                        if(index == -1){
                            //* Fixes bug where pressing tab selects next cell and makes it editable
                            var table = $$('tableBuilder' + el.uid);
                            table.editCancel();
                            table.clearSelection();
                            return false;
                        }
                        else{
                            return true;
                        }
                    }
                }
            }),
            template: `
                <div>
                    <h2>{{this.name}}</h2>
                    <h4>{{this.description}}</h4>
                    <webix-table-display v-if="finishedLoading" :config="config"/>
                    <b-button @click="returnInputValues" class="mt-2" variant="success" v-if="isEditable">
                        Save Table
                    </b-button>
                </div>
            `,
            watch: {
                finishedLoading(newVal) {
                    if (newVal) {
                        this.$nextTick(() => {
                            //eslint-disable-next-line no-undef
                            var el = this;
                            var table = $$('tableBuilder' + el.uid);
                            table.attachEvent

                            //*Loop through data and apply value to cells
                            this.data.forEach(item => { //currency, decimal, percentage,
                                var [row, column] = item.mapped_cell_id.split('|');
                                table.updateItem(row, {
                                    [column]: item.value
                                })
                            })
                            table.refresh();

                            //* Apply formatting to cells
                            this.mapping.forEach(item => {
                                var [row, column] = item.mapped_cell_id.split('|');

                                //* Get the current cells value
                                var cell_value = table.getItem(row);
                                cell_value = cell_value[column];

                                switch (item.data_type) { //currency, decimal, percentage,
                                    case 'percentage':
                                        cell_value = (!cell_value || cell_value.length == 0 ? 0 : cell_value);
                                        cell_value = parseInt(cell_value);
                                        cell_value = (cell_value * 100) + '%';
                                        break;
                                    case 'currency':
                                        cell_value = (!cell_value || cell_value.length == 0 ? 0 : cell_value);
                                        cell_value = parseInt(cell_value);
                                        cell_value = webix.i18n.priceFormat(cell_value);
                                        break;
                                    case 'decimal':
                                        cell_value = (!cell_value || cell_value.length == 0 ? 0 : cell_value);
                                        cell_value = parseInt(cell_value);
                                        cell_value = webix.i18n.numberFormat(cell_value)
                                        break;
                                    default:
                                        break;
                                }
                                table.updateItem(row, {
                                    [column]: cell_value
                                })
                            })
                            table.refresh();
                        });
                    }
                }
            },
            methods:{
                returnInputValues(){
                    let table = $$('tableBuilder' + this.uid);
                    let form_data = [];
                    this.config.editableCells.forEach( cell => {
                        let id = cell.id.split('|');
                        let record = table.getItem(id[0]);
                        let value = record[id[1]];

                        form_data.push(
                            {
                                key: cell.key,
                                value: value
                            }
                        );
                    })

                    this.$emit('savedFormData', form_data);
                }
            },
            mounted() {
                //* Add editable cell onClick check if the table config
                //* supports cell editing.
                if(this.isEditable){
                    this.config.columns.forEach( column => {
                        column['editor'] = 'text';
                        column['editaction'] = 'custom';
                    })
                    this.config.select = 'cell';
                    this.config['editable'] = true;
                    this.config['on'] = this.editableClick;
                }


                //*Import locale and then set selected locale
                this.uid = webix.uid();
                this.config.id = 'tableBuilder' + this.uid;
                import(`./locales/webix/en-ZA.module.js`).then(() => {
                    webix.i18n.setLocale('en-ZA');
                    this.finishedLoading = true;
                })
                /*this.$nextTick(()=>{
                    this.finishedLoading = true;
                })*/
                
            },
            props: { // plugin props
                config: {
                    type: Object,
                    required: true,
                },
                data: {
                    type: Array,
                    require: true,
                },
                name: {
                    type: String,
                    require: false,
                },
                description: {
                    type: String,
                    require: false,
                },
                locale: {
                    type: String,
                    required: false,
                    default: function () {
                        return 'en-ZA'
                    }
                },
                mapping: {
                    type: Array,
                    required: true,
                },
                isEditable:{
                    type: Boolean,
                    required: false,
                    default:function(){
                        return false;
                    }
                }
            },
        })
    }
}